import { render, staticRenderFns } from "./recentOrders.vue?vue&type=template&id=d5f92120"
import script from "./recentOrders.vue?vue&type=script&lang=js"
export * from "./recentOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports